import { BrowserModule, ɵDomRendererFactory2 } from '@angular/platform-browser';
import { registerLocaleData, LocationStrategy, PathLocationStrategy, APP_BASE_HREF } from '@angular/common';
import { NgModule, LOCALE_ID, ErrorHandler, Injectable, TemplateRef, ElementRef, Renderer2, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);
import { FormsModule } from '@angular/forms';
import { RouterModule, PreloadAllModules, Routes } from '@angular/router';
// import { TabsModule, AlertModule, TooltipModule, ModalModule} from 'ngx-bootstrap';

import { BsDropdownConfig, BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsModalRef, ModalDirective, ModalModule } from 'ngx-bootstrap/modal';

// import { ScheduleModule } from 'primeng/primeng';
import { NgChartsModule   } from 'ng2-charts';


import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Observable } from 'rxjs';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';

import { rootRouterConfig } from './app.routes';

/*import { RecylogModule } from './recylog/recylog.module';
import { EcobennesModule } from './ecobennes/ecobennes.module';
import { EcofactModule } from './ecofact/ecofact.module';
import { EcolocModule } from './ecoloc/ecoloc.module';
import { EcorhModule } from './ecorh/ecorh.module';
import { EcocrmModule } from './ecocrm/ecocrm.module';*/
import { ShardedModule } from './sharded/sharded.module';

import { environment } from '../environments/environment';
import { HttpService } from './commons/services/http.service';
import { LocalStorageService } from './commons/services/local_storage.service';
import { CommonService } from './commons/services/common.service';
import { AlertService } from './commons/services/alert.service';
import { QzTrayService } from './commons/services/qz-tray.service';
import { VersionCheckService } from './commons/services/version-check.service';
/*import { SafePipe } from './ecoportail/home-ecoportail/video/video.component';*/
import { WaitpromiseService } from './commons/services/waitpromise.service';



import { MenuComponent } from './menu/menu.component';
import {MatCardModule} from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { IconsTuilesComponent } from './home/icons-tuiles/icons-tuiles.component';
import { AproposEcorecComponent } from './commons/apropos-ecorec/apropos-ecorec.component';

import { CreateDevisOpenIdComponent } from './ecocrm/create-devis-open-id/create-devis-open-id.component';
import { EmptyDetailDevisComponent } from './ecocrm/gestion-devis/empty-detail-devis/empty-detail-devis.component';
import { LoadingComponent } from './loading/loading.component';
import { AccessEcoportailComponent } from "./ecoportail/access-ecoportail/access-ecoportail.component";
import { AuthGuard, AuthGuardEcorec } from "./commons/services/auth-guard.service";
import { Element } from '@angular/compiler';
import { QueueHttpInterceptor } from './commons/services/queue-http.interceptor';




const routeEcorec = [...environment.routes, ...rootRouterConfig];
// routeEcorec.forEach(elt => {
//   elt['canActivate'] = [AuthGuardEcorec];
// })
const routeApp = !environment.moduleEcoportailOnly ? [...routeEcorec] : [...environment.routes];


const routeApp1: Routes = [
  { path: 'empty', component: EmptyDetailDevisComponent },
  { path: 'loading', component: LoadingComponent },
  {
    path: 'access/:id',
    component: AccessEcoportailComponent,
  },
  {
    path: 'creationDevis/:codeExterneClient/:codeExterneAffaire',
    component: CreateDevisOpenIdComponent,
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'creationDevis/:codeExterneClient',
    component: CreateDevisOpenIdComponent,
    // runGuardsAndResolvers: 'always',
  }
];


const moduleEcorec = [
  BrowserModule,
  BrowserAnimationsModule,
  HttpClientModule,
  //  RouterModule.forRoot( !environment.isOpenId ? routeApp : routeApp1),
  RouterModule.forRoot([...routeApp, ...routeApp1],
    { useHash: true, preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' }),
  // RouterModule.forRoot(routeApp, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' }),
  ShardedModule,
  TabsModule.forRoot(),
  AlertModule.forRoot(),
  TooltipModule.forRoot(),
  ModalModule.forRoot(),
  FormsModule,
  NgChartsModule,
  MatCardModule,
  MatGridListModule,
  MatProgressBarModule,
  NgxDatatableModule,
  BsDropdownModule.forRoot(),
  NgbModule,
  BrowserAnimationsModule,
];

const exp = environment.production ? '' : '';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  handleError(error: any) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }

    if (typeof error === 'string' && error.includes('ERREURSERVEUR')) {
      // console.error(error)
    } else {
      if (error.stack && error.stack.includes('ERREURSERVEUR')) {

      } else {
        console.error(error);
      }
    }
  }
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(public common: CommonService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.common.local.get('token');
    if (req.url && req.url.includes('execute/servlet') && environment.isOpenId) {
      req = req.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`,
          // 'Authorization': `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjEzZThkNDVhNDNjY`,
        },
      });
    }

    return next.handle(req);
  }
}


const entriecomponent = [
  AppComponent,
  HomeComponent,
  MenuComponent,
  IconsTuilesComponent,
  AproposEcorecComponent,
  LoadingComponent,

];

@NgModule({
  //  declarations: [...entriecomponent, (environment.isOpenId ? ...[CreateDevisOpenIdComponent] : ...[])],
  declarations: [...entriecomponent],
  imports: [...moduleEcorec],
  exports: [FormsModule, BrowserAnimationsModule],
  providers: [HttpService, LocalStorageService,
    CommonService, AlertService, VersionCheckService, QzTrayService, WaitpromiseService, AuthGuardEcorec,
    // { provide: APP_BASE_HREF, useValue: exp },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    // {provide: LocationStrategy, useClass: PathLocationStrategy},
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: QueueHttpInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
}



